import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { MissingDataSeller } from "./MissingDataSeller";
import { MissingDataBuyer } from "./MissingDataBuyer";
import { Tables } from "./Tables";
import { Page } from "v2/components";

import { useAuth } from "contexts/auth";
import api from "services/api";
import { getContractDisplayName } from "v2/utils/getContractDisplayName";

interface IResponse {
  id: string; //workspace_id
  workspaceRules?: Array<{
    params?: {
      payload?: {
        rules?: {
          rulesRegister?: {
            policyContractNumber?: string;
          };
        };
      };
    };
  }>;
  sellerOrganization: {
    id: string;
    corporateName: string;
  };
  buyerOrganization: {
    id: string;
    corporateName: string;
  };
  product: {
    id: string;
    name: string;
    productType: string;
    supplierOrganization: {
      id: string;
      corporateName: string;
    };
  };
}

export function MissingData() {
  const { workspaceId, templateId } = useParams() as { workspaceId: string; templateId: string; };
  const user = useAuth();

  const isBuyer = ["77710728000131", "59291534000167", "47756998000112", "31439951000195", "34499567000176", "00278017000105"].includes(user?.user?.organization?.cnpj ?? "");
  const isSeller = ["75612521000107"].includes(user?.user?.organization?.cnpj ?? "");

  const { data, isFetching, isFetched, isError } = useQuery({
    queryKey: ["pageDetail", workspaceId],
    queryFn: () => api.get<{ data: IResponse }>(`/v2/workspaces/${workspaceId}/get-details`),
    select: (data) => data.data.data,
  });

  return (
    <>
      {!isFetched && isFetching && <div>Loading...</div>}
      {!isFetched && isError && <div>Error...</div>}
      {data && (
        <Page title={getContractDisplayName(data)} backRoute={`/v2/workspaces/${data.id}`}>
          <Page.Tab name="Atividades">
            <>
              {!isSeller ? (
                <MissingDataBuyer buyerOrganizationId={data.buyerOrganization.id} />
              ) : (
                <MissingDataSeller buyerOrganizationId={data.buyerOrganization.id} />
              )}
            </>
          </Page.Tab>
          <Page.Tab name="Histórico" disabled />
          <Page.Tab name="Contrato" disabled />
          <Page.Tab name="Tabelas">
            <Tables />
          </Page.Tab>
        </Page>
      )}
    </>
  );
}
